export default __webpack_public_path__ + "static/media/star-filled.c2825f63.svg";